.sheet-layer {
  position: fixed;
  inset: 0;
  z-index: 60;
  pointer-events: none;
}
.sheet-layer[data-open='true'] {
  pointer-events: auto;
}

.sheet-backdrop {
  position: absolute;
  inset: 0;
  background: var(--backdrop);
  opacity: 0;
  transition: opacity 0.22s ease;
  touch-action: none;
}
.sheet-layer[data-open='true'] .sheet-backdrop {
  opacity: 1;
}

.sheet {
  position: absolute;
  left: 0;
  right: 0;
  bottom: var(--keyboard);
  max-height: calc(100dvh - var(--keyboard) - var(--safe-top) - 24px);
  display: flex;
  flex-direction: column;
  background: var(--surface);
  border: 1px solid var(--border-2);
  border-bottom: 0;
  border-radius: 22px 22px 0 0;
  box-shadow: var(--shadow-raised);
  /* Without the keyboard the home indicator is under the sheet's bottom edge;
     with it, the keyboard is, and the inset would only be dead space. */
  padding-bottom: var(--safe-bottom);
  transform: translateY(calc(100% + 24px));
  transition: transform 0.28s var(--ease-out), bottom 0.12s ease-out;
  overscroll-behavior: contain;
}
:root[data-keyboard] .sheet {
  padding-bottom: 0;
}
.sheet-layer[data-open='true'] .sheet {
  transform: translateY(var(--drag, 0px));
}
.sheet.dragging {
  transition: none;
}

.sheet-grip {
  flex: none;
  display: grid;
  place-items: center;
  height: 22px;
  touch-action: none;
  cursor: grab;
}
.sheet-grip span {
  width: 36px;
  height: 5px;
  border-radius: 3px;
  background: var(--border-3);
}

@media (min-width: 720px) {
  .sheet {
    left: 50%;
    right: auto;
    width: min(560px, calc(100vw - 48px));
    bottom: calc(var(--keyboard) + 24px);
    border-bottom: 1px solid var(--border-2);
    border-radius: 20px;
    padding-bottom: 0;
    transform: translate(-50%, calc(100% + 48px));
  }
  .sheet-layer[data-open='true'] .sheet {
    transform: translate(-50%, var(--drag, 0px));
  }
}

/* --- picker ---------------------------------------------------------------- */

.picker {
  padding: 2px 0 10px;
  overflow-y: auto;
}
.picker-title {
  padding: 4px 20px 10px;
  font-size: 13px;
  font-weight: 600;
  color: var(--fg-3);
}
.picker-list {
  list-style: none;
  margin: 0;
  padding: 0 8px;
}
.picker-option {
  width: 100%;
  min-height: 50px;
  display: flex;
  align-items: center;
  gap: 14px;
  padding: 0 12px;
  border-radius: 12px;
  text-align: left;
  font-size: 16px;
  font-weight: 600;
}
.picker-option:active {
  background: var(--panel-2);
}
@media (hover: hover) {
  .picker-option:hover {
    background: var(--panel);
  }
}
.picker-icon {
  width: 20px;
  display: grid;
  place-items: center;
  color: var(--fg-2);
}
.picker-label {
  flex: 1;
  min-width: 0;
}
.picker-hint {
  font-size: 11.5px;
  color: var(--fg-3);
}
.picker-check {
  width: 20px;
  display: grid;
  place-items: center;
  color: var(--fg);
}
